import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../components/Button/Button';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdownmenu from '../../../components/Dropdownmenu/Dropdownmenu';
import './AdMentorStyle.css'
import { useNavigate } from 'react-router-dom';
import Deletepoup from '../../../components/Popups/Deletepoup/Deletepoup';
import { useDispatch, useSelector } from 'react-redux';
import { adminData, clearState, clearUsers, deleteUser, getAllMentors } from "../../../reducer/adminSlice";
import moment from 'moment';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';
import Skeleton from 'react-loading-skeleton';


const AdMentor = () => {

    const numbers = [1, 2, 3, 4, 5]

    const [viewdropdown, setviewdropdown] = useState();
    const [deleteToggler, setDeleteToggler] = useState();
    const [upcomingtab, setUpcomingTab] = useState(1);

    //Temporary State
    const [selectedMentor, setSelectedMentor] = useState("");
    const [totalCount, setTotalCount] = useState(0);

    //Search states
    const [search, setSearch] = useState("");

    //Filter states
    const [program, setProgram] = useState("");
    const [companies, setCompanies] = useState([]);

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalMentors, setTotalMentors] = useState([]);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isMentorFetching, isSuccess, isError, errorMessage, allMentors, isLoaderFetching } = useSelector(adminData);

    //Delete Functions
    const handleDeleteMentor = () => {
        dispatch(deleteUser(selectedMentor));
    };

    const handleCloseDelete = () => {
        setSelectedMentor("");
        setDeleteToggler(false);
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        setTotalMentors([]);
        setIndex(1);
        dispatch(getAllMentors({ search, user: "mentor", program }));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalMentors([]);
            setIndex(1);
            dispatch(getAllMentors({ search, user: "mentor", program }));
        }
    };

    //Filter Functions
    const handleProgramFilter = (e) => {
        const { value } = e.target;
        setProgram(value);
    };

    const handleCompanyFilter = (company) => {
        setIndex(1);
        setTotalMentors([]);
        dispatch(getAllMentors({ search, user: "mentor", program, index, company }));
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        dispatch(getAllMentors({ search, user: "mentor", program, index: index + 1 }));
    };

    useEffect(() => {
        dispatch(getAllMentors({ user: "mentor" }));

        return () => {
            dispatch(clearUsers());
        }
    }, []);

    //Load more useEffects
    useEffect(() => {
        if (index === 1 && allMentors?.users?.length > 0) {
            setTotalMentors(allMentors?.users);
            setCompanies([...new Set(allMentors?.users?.map(item => {
                return {
                    label: item?.profession?.company,
                    value: item?.profession?.company,
                }
            }).filter(item => item.label))])
        }
        if (index !== 1 && allMentors?.users?.length > 0) setTotalMentors(prev => [...prev, ...allMentors?.users]);
        if (allMentors?.totalCount) setTotalCount(allMentors?.totalCount);
    }, [allMentors]);

    useEffect(() => {
        if (isSuccess) {
            dispatch(clearState());
            setTotalMentors([]);
            setIndex(1);
            dispatch(getAllMentors({ user: "mentor" }));
            setDeleteToggler(false);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            // setTotalMentors(allMentors);
            setIndex(1);
            setIsShowError(true);
            setErrMessage(errorMessage);
            // dispatch(getAllMentors({user: "mentor"}));
            dispatch(clearState());
        }
    }, [isError]);

    const targetRef = useRef(null);

    useEffect(() => {

        const element = document.querySelector(".CallHistoryTabledata");
        const element1 = document.querySelector(".innerdiv");

        const handleScroll = () => {
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (
        <>
            {isLoaderFetching && <PageLoader />}
            <Deletepoup isActive={deleteToggler} handleClose={handleCloseDelete} handleDelete={handleDeleteMentor} />
            <div className="callHIstoryWrap">


                <div className="headingwrap flex-between">
                    <div>
                        <h2 className='heading-2 mb6'>Mentors</h2>
                        {isMentorFetching ? <Skeleton width={"80px"} /> : <p className='text3'>Total {allMentors?.totalCount ?? 0}</p>}
                    </div>

                    <Button className={'BlueFillButton iconButton buttontext'} name={'Add Mentor'} src={'/assets/svg/add-circle.svg'} onClick={() => navigate('/admin/add-mentor')} />
                </div>

                <div className={`commonTableWrapper AdcommonWrapperforAll`}>
                    <div className="FaqUserFiltter flex-between">
                        {<SearchBar className={"searchbardesign"} placeholder={'Search by Name'} value={search} onChange={handleSearchChange} onClick={handleSearch} onKeyDown={handleSearchPress} />}
                        {<div className="FilterButtonPast flex gap-10" >
                            <input type='text' placeholder={`Showing ${totalMentors?.length ?? 0} out of ${totalCount}`} disabled className='disabledInput' />
                            {/* <label htmlFor="date" className='Cudatedesign'>
                                <input type="date" id='date' />
                            </label> */}
                        </div>}
                    </div>

                    <div className={`CallHistoryTabledata mt20 fixmentorgap1 Tabusesate ${upcomingtab === 1 && 'active'}`}>

                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Mentor</th>
                                        <th>
                                            <div className='dropdownwrapper flex pointer' onClick={() => setviewdropdown(!viewdropdown)}>Company
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.4534 4.77173H6.81926H3.54676C2.98676 4.77173 2.70676 5.4484 3.10343 5.84506L6.1251 8.86673C6.60926 9.35089 7.39676 9.35089 7.88093 8.86673L9.0301 7.71756L10.9026 5.84506C11.2934 5.4484 11.0134 4.77173 10.4534 4.77173Z" fill="#737373" />
                                                </svg>
                                                <Dropdownmenu setviewdropdown={setviewdropdown} viewdropdown={viewdropdown} options={companies} onChange={handleCompanyFilter} />
                                            </div>
                                        </th>
                                        <th>Rating</th>
                                        <th>Available Slots</th>
                                        <th><div className='flex headingtablediv'>
                                            Delivered solutions
                                            {/* <div className='iconsdatadev ml4'>
                                            <img src="/assets/img/icons/up.png" alt="" />
                                            <img src="/assets/img/icons/down.png" alt="" />
                                        </div> */}
                                        </div>
                                        </th>
                                        <th>Actions</th>
                                    </tr>

                                </thead>
                            </table>
                        </div>

                        <div className="innerdiv">
                            <table>
                                <tbody>
                                    {totalMentors?.length > 0 ? totalMentors?.map((item, index) => (
                                        <tr key={index} >
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.profileImg ? item?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => { navigate(`/admin/mentor-profile/${item?.id}`) }}>{item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.profession?.designation ? item?.profession?.designation : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.profession?.company ? item?.profession?.company : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <div className="ratingstaricons">
                                                        {numbers?.map((num) => (
                                                            <>
                                                                {num <= (+item?.averageRating).toFixed(0) ?
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9.36946 1.20194L10.7794 4.02194C10.9694 4.41194 11.4794 4.78194 11.9094 4.86194L14.4595 5.28195C16.0895 5.55195 16.4694 6.73194 15.2994 7.91194L13.3094 9.90194C12.9794 10.2319 12.7895 10.8819 12.8995 11.3519L13.4694 13.8119C13.9194 15.7519 12.8794 16.5119 11.1694 15.4919L8.77943 14.0719C8.34943 13.8119 7.62944 13.8119 7.19944 14.0719L4.80943 15.4919C3.09943 16.5019 2.05944 15.7519 2.50944 13.8119L3.07945 11.3519C3.18945 10.8919 2.99945 10.2419 2.66945 9.90194L0.679455 7.91194C-0.490545 6.74194 -0.110549 5.56195 1.51945 5.28195L4.06944 4.86194C4.49944 4.79194 5.00944 4.41194 5.19944 4.02194L6.60945 1.20194C7.35945 -0.328057 8.59946 -0.328057 9.36946 1.20194Z" fill="#FFCD42" />
                                                                    </svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M8 1.34302L10.163 5.72502L15 6.43202L11.5 9.84101L12.326 14.657L8 12.382L3.674 14.657L4.5 9.84101L1 6.43202L5.837 5.72502L8 1.34302Z" fill="white" stroke="#FFCD42" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>}
                                                            </>
                                                        ))}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.totalSlots ? item?.totalSlots : 0}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.totalCalls ? item?.totalCalls : 0}</h4>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="tableBox">
                                                    <div className="tableBox">
                                                        {/* <span className="tooltip calendar pointer" data-tooltip="View Slots" >
                                                        <img src="/assets/img/calendarpur.png" alt="" />
                                                    </span> */}
                                                        <span className='tooltip pointer' data-tooltip="Delete" onClick={() => { setDeleteToggler(true); setSelectedMentor(item?.id) }}>
                                                            <img src="/assets/svg/trash.svg" alt="" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : !isMentorFetching && <DatanotFound />}
                                    {isMentorFetching &&
                                        <>
                                            {[1, 2, 3, 4].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"150px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className="ratingstaricons">
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"50px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"50px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className="tableBox">
                                                                <Skeleton width={"20px"} height={"20px"} circle />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>

                            {(!isMentorFetching && (totalMentors.length < allMentors?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef} >
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                            </div>}
                        </div>

                        {/* {(!isMentorFetching && (totalMentors.length < allMentors?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef} >
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>} */}
                    </div>
                </div>
                {/* <Paginationarrow /> */}
            </div>
        </>

    )
}

export default AdMentor